module.exports = __webpack_public_path__ + "media/ברווז.86359c9c.mp3";